import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@uhg-abyss/web/ui/Alert';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import Markdown from 'markdown-to-jsx';
import { LagoonContext } from '../../AppContext';
import { LagoonStyledButton } from '../LagoonStyledButton/LagoonStyledButton';

export const CommonAlert = ({ alertType }) => {
  const lagoonContext = React.useContext(LagoonContext);
  const contentManagement = lagoonContext?.getTable('custom-alerts').getRow();
  const alertList = contentManagement;
  const { navigate } = useRouter();

  const lagoonCommonAlertDetails =
    alertList?.length > 0
      ? alertList?.filter((el) => {
          return el.active && el.alertType === alertType;
        })?.[0]
      : null;

  const {
    variant,
    message,
    title,
    icon,
    isClosable,
    active,
    buttonText,
    buttonLink,
  } = lagoonCommonAlertDetails || {};

  const [isVisible, setIsVisible] = useState(active);

  const onAction = () => {
    if (buttonLink) {
      setIsVisible(false);
      navigate(buttonLink);
    }
  };

  const getCustomAlertProps = {
    title,
    inlineText: (
      <Markdown
        id={`marketplace-${alertType}-alert-text`}
        options={{
          overrides: {
            a: {
              component: LagoonStyledButton,
              props: { size: '14px' },
            },
          },
        }}
      >
        {message}
      </Markdown>
    ),
    variant,
    isVisible,
    onClose: isClosable
      ? () => {
          return setIsVisible(false);
        }
      : null,
    actionText: buttonText,
    onAction,
  };

  if (icon) {
    getCustomAlertProps.icon = <IconSymbol icon={icon} />;
  }

  return active ? (
    <Alert
      {...getCustomAlertProps}
      css={{
        '.abyss-alert-title': {
          fontWeight: 700,
          fontSize: '14px',
          lineHeight: '24px',
        },
        '.abyss-alert-inline-text': {
          fontWeight: 400,
          fontSize: '14px',
          lineHeight: '24px',
        },
      }}
    />
  ) : (
    ''
  );
};

CommonAlert.propTypes = {
  alertType: PropTypes.string.isRequired,
};
